<template>
  <div :class="['userpic', size ? 'userpic--' + size : '']">
    <img :src="getImageSrc"
         :srcset="getImage2xSrc + ' 2x'"
         :alt="$t('labels.photo')">
  </div>
</template>
<script>
  import 'src/assets/sass/paper/_variables.scss'
  import {CONF_BASE_URL} from '@/constants'
  import config from 'src/config'

  export default {
    name: 'ui-avatar',
    props: [
      'upic',
      'name',
      'size'
    ],
    data () {
      return {
        imageSrc: null,
        imageSize: 'ic',
        baseUrl: config(CONF_BASE_URL)
      }
    },
    computed: {
      getImageSrc () {
        if (this.upic) {
          return this.baseUrl + '/files/upic/get?id=' + this.upic + '&size=' + this.getImageSize(this.size)
        } else {
          return this.getDefaultUserpic(this.name, this.size)
        }
      },
      getImage2xSrc () {
        if (this.upic) {
          return this.baseUrl + '/files/upic/get?id=' + this.upic + '&size=' + this.getImageSize2x(this.size)
        } else {
          return this.getDefaultUserpic(this.name, this.size)
        }
      }
    },
    methods: {
      getImageSize (size) {
        switch (size) {
          case 'ic':
            return '_ic';
          case 'small':
            return '_sm';
          case 'medium':
            return '_md';
          default:
            return '_orig';
        }
      },
      getImageSize2x (size) {
        switch (size) {
          case 'ic':
            return '_sm';
          case 'small':
            return '_md';
          case 'medium':
            return '_orig';
          default:
            return '_orig';
        }
      },
      getDefaultUserpic (name, size) {
        name = name || '';
        size = getImageSize();

        function getImageSize () {
          switch (size) {
            case 'ic':
              return 100;
            case 'small':
              return 200;
            case 'medium':
              return 400;
            default:
              return 400;
          }
        }

        let colours = [
          '#1abc9c', '#2ecc71', '#3498db', '#9b59b6', '#34495e', '#16a085', '#27ae60', '#2980b9',
          '#8e44ad', '#2c3e50',
          '#f1c40f', '#e67e22', '#e74c3c', '#ecf0f1', '#95a5a6', '#f39c12', '#d35400', '#c0392b',
          '#bdc3c7', '#7f8c8d'
        ]

        let nameSplit = String(name)
          .toUpperCase()
          .split(' ')

        let charCodeSum = name.split('').map((c) => { return c.charCodeAt(0) }).reduce((a, b) => a + b, 0);

        let initials, charIndex, colourIndex, canvas, context, dataURI;

        if (nameSplit.length === 1) {
          initials = nameSplit[0] ? nameSplit[0].charAt(0) : '?';
        } else {
          initials = nameSplit[0].charAt(0) + nameSplit[1].charAt(0);
        }

        if (window.devicePixelRatio) {
          size = (size * window.devicePixelRatio);
        }

        charIndex = (initials === '?' ? 72 : charCodeSum) - 64;
        colourIndex = charIndex % colours.length;
        canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        context = canvas.getContext('2d');

        context.fillStyle = colours[colourIndex];
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.font = Math.round(canvas.width / 2) + 'px Arial';
        context.textAlign = 'center';
        context.fillStyle = '#FFF';
        context.fillText(initials, size / 2, size / 1.5);

        dataURI = canvas.toDataURL();
        canvas = null;

        return dataURI;
      }
    }
  }
</script>
<style lang="scss">
  $screen-sm:           768px;
  $screen-md:           992px;
  $screen-lg:           1200px;

  .userpic {
    position: relative;
    display: inline-block;
    width: 300px;
    height: 300px;
    border-radius: 100%;
    overflow: hidden;

    @media only screen and (max-width: $screen-sm){
      width: 240px;
      height: 240px;
    }

    img {
      width: 100%;
    }

    &__default {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: red;
    }

    &--medium {
      width: 150px;
      height: 150px;
    }

    &--small {
      width: 100px;
      height: 100px;
    }

    &--ic {
      width: 40px;
      height: 40px;
    }
  }
</style>